import React from 'react'
import { ReactComponent as SpadeSVG } from '../../../lib/assets/suits/spades.svg'
import { ReactComponent as HeartSVG } from '../../../lib/assets/suits/heart.svg'
import { ReactComponent as ClubSVG } from '../../../lib/assets/suits/club.svg'
import { ReactComponent as DiamondSVG } from '../../../lib/assets/suits/diamond.svg'

export const handleCardSuit = (c: string): any => {
  const cardSuit = c.charAt(0)
  switch (cardSuit) {
    case 'S':
      return <SpadeSVG />
    case 'C':
      return <ClubSVG />
    case 'H':
      return <HeartSVG />
    case 'D':
      return <DiamondSVG />
    default:
      return
  }
}
